import { DataSource, Editor, FulfillmentPlant } from '.'

export interface SearchFilter {
  type: SearchTypes
  query: string
}

export type SearchResult = CustomerSearchResult & OrderSearchResult

export interface SearchResponse<T = SearchResult> {
  items: T[] | undefined
  hasMore: boolean
  offset: number
  limit: number
}

export interface JustSearchResponse {
  orders?: OrderSearchResult[]
  customers?: CustomerSearchResult[]
}

export interface OrderSearchResult {
  id: string
  createdDateTime: Date
  vendor: string
  channel: string
  source: DataSource
  matchedProductCode?: string
  isOldLegacyOrder?: boolean
  accountType?: string
  matchReason?: string
}

export interface ProductContentSearchResult {
  orderCode: string
  productCode: string
  contentId: string
  isOrderSupported?: boolean
}

export interface ProductListItem {
  id: string
  productId: string
  productTitle: string
  selected: boolean
  thumbnailId?: string
  reUploadPermitted?: boolean
  quantity?: number
  editor?: Editor
  plant?: FulfillmentPlant
}

export interface CustomerSearchResult {
  id: string
  source: number
  name: string
  email: string
  phone: string
  score: number
  matchReason?: string
  accountType?: string
}

export interface MixupSearchFilter {
  byOrder?: string
  byTicket?: string
}

export interface MixupSearchResponse {
  items?: any[]
  paginationToken: string
  limit: number
  hasMore: boolean
}

export enum SearchTypes {
  ByOrderCode = 0,
  ByCustomerEmail = 1,
  ByCustomerPhone = 2,
  ByTicketId = 3,
  ByCustomerName = 4,
  ByAddress = 5,
  ByTrackingCode = 6,
  ByProductContent = 7,
  JustSearch = 8,
}

export const SearchTypesDisplayNames: { [type: number]: string } = {
  [SearchTypes.ByOrderCode]: 'Order Number',
  [SearchTypes.ByCustomerEmail]: 'Email',
  [SearchTypes.ByCustomerPhone]: 'Phone',
  [SearchTypes.ByTicketId]: 'Barcode',
  [SearchTypes.ByCustomerName]: 'Name',
  [SearchTypes.ByAddress]: 'Address',
  [SearchTypes.ByTrackingCode]: 'Tracking Number',
  [SearchTypes.ByProductContent]: 'Product Content',
  [SearchTypes.JustSearch]: "I'm Lucky",
}

export enum CustomerSearchSortingType {
  ByEmail,
  ByScore,
}
